module.exports = __webpack_public_path__ + "img/rating_4.11aa2285.png";